import { buildAlignedTotalsRow, getColumnIndex } from '@components/shared/Table/helpers/buildAlignedTotalsRow'
import { numberMask } from '@utils/masks/cpfMask'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { OtherServicesResponseProps } from '@pages/InvoicingClientModal/context/types'

interface ParseOtherServicesTotalsProps {
  columns: ColumnDefProps[]
  data: OtherServicesResponseProps | null
}

/**
 * Linha de totais de Outros Serviços (tela e modal do cliente): Total Bruto sob "Total Bruto" e
 * Total Líquido sob "Total Líquido".
 */
export const parseOtherServicesTotalsGrid = ({
  columns,
  data
}: ParseOtherServicesTotalsProps): ColumnDefProps[][] => {
  if (!columns.length || !data) return []

  const totalsRow = buildAlignedTotalsRow({
    columns,
    label: `Total Registros: ${numberMask(String(data.totalItems || 0))}`,
    labelSpan: getColumnIndex(columns, 'grossTotal'),
    values: {
      grossTotal: { label: 'Total Bruto', value: data.grossTotalAmount || 0, currency: true },
      netTotal: { label: 'Total Líquido', value: data.netTotalAmount || 0, currency: true }
    }
  })

  return totalsRow.length ? [totalsRow] : []
}
